import React from 'react';
import { isRiskyCommandError } from '@splunk/dashboard-utils';
import RiskyWarningPopoverContent from './RiskyWarningPopoverContent';
import type { PopoverContentFactoryProps } from './PopoverContentFactory';
import GenericPopoverContentFactory from './PopoverContentFactory';
import getStatusMessage from './utils/getStatusMessage';

interface EnterpriseContentFactoryProps extends PopoverContentFactoryProps {
    componentId: string;
    onRequestClose: () => void;
    type?: string;
}

export default ({
    dataSource,
    message,
    componentId,
    onRequestClose,
    type = 'visualization',
}: EnterpriseContentFactoryProps) => {
    if (!dataSource) {
        return <GenericPopoverContentFactory message={message} />;
    }

    const statusMessage = getStatusMessage(dataSource);

    if (statusMessage && isRiskyCommandError(statusMessage)) {
        return (
            <RiskyWarningPopoverContent
                dataSource={dataSource}
                componentId={componentId}
                onRequestClose={onRequestClose}
                type={type}
            />
        );
    }

    return (
        <GenericPopoverContentFactory
            dataSource={dataSource}
            message={message}
        />
    );
};
